import { ArrowTooltip } from '@/components/arrow-tooltip.js';
import { cn } from '@/lib/tailwind-utils.js';
import { Star } from 'lucide-react';

export const HIGH_PRIORITY_SCHOOL_LABEL = 'High priority school';

interface HighPrioritySchoolIndicatorProps {
  isHighPriority?: boolean | null;
  className?: string;
  'data-testid'?: string;
}

export function HighPrioritySchoolIndicator({
  isHighPriority,
  className,
  'data-testid': dataTestId,
}: HighPrioritySchoolIndicatorProps) {
  if (!isHighPriority) {
    return null;
  }

  return (
    <ArrowTooltip
      asChild
      trigger={
        <button
          type="button"
          className={cn(
            'inline-flex shrink-0 rounded-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2',
            className,
          )}
          aria-label={HIGH_PRIORITY_SCHOOL_LABEL}
          data-testid={dataTestId}
        >
          <Star className="h-4 w-4 fill-amber-400 text-amber-400" aria-hidden />
        </button>
      }
    >
      {HIGH_PRIORITY_SCHOOL_LABEL}
    </ArrowTooltip>
  );
}
